export default __webpack_public_path__ + "static/second-41abde2a8b62df8821baa4316b036b56.png";